<template>
    <div class="checkbox">
        <span class="checkbox__block">
            <input :id="id" class="checkbox__el" type="checkbox"
                   :checked='checked'
                   :disabled="disabled"
                   :name="name"
                   v-bind="$attrs"
                   v-on="$listeners"
                   @change="$emit('change', $event.target.checked)"
            >
            <span class="checkbox__in" :class="invalid">
                <svg v-svg
                     symbol="checkbox"
                     class="checkbox__icon"
                     role="presentation"
                />
            </span>
        </span>
        <label class="checkbox__label" :for="id"><slot></slot></label>
    </div>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
    },
    error: {
      type: Boolean,
    },
    disabled: {
      type: Boolean,
    },
    name: {
      type: String,
    },
    checked: {
      type: Boolean,
    },

  },
  computed: {
    invalid() {
      return this.error ? 'checkbox-error' : '';
    },
  },
};
</script>

